import PerfilCandidate from "./perfilCandidate";

export default PerfilCandidate;
